<template>
  <div class="index">
    <div class="setbox">
      <el-form ref="editForm" :model="editForm" label-width="80px">
        <el-form-item label="敏感词：">
          <el-input type="textarea" :rows="10" placeholder="请输入内容" v-model="keyword">
          </el-input>
        </el-form-item>
        <div class="buttonbox">
          <el-button @click="rvoke()">撤销修改</el-button>
          <el-button type="primary" @click="submit()">保&emsp;存</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      editForm:{},
      requestData:{},//请求到的数据
      keyword:""
    }
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.getKeyWord()
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    
  },
  methods:{
    getKeyWord() {
      this.$api.getGlobalSetting().then(res => {
        if (res.data.status == 0) {
          this.requestData = JSON.parse(res.data.data)[0]
          this.keyword = this.requestData.filterKeyWord.join(" ")
        } else {
          this._status(res.data)
        }
      })
    },
    rvoke() {
      if (this.keyword != this.requestData.filterKeyWord.join(" ")) {//内容发生改变
        this.$confirm('确认将修改的信息复原吗？?', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.keyword = this.requestData.filterKeyWord.join(" ")
        }).catch(() => {});
      } else {
        this.$message.info("未修改内容，无需撤销")
      }
    },
    submit() {
      if (this.keyword != this.requestData.filterKeyWord.join(" ")) {//内容发生改变
        let newData = {}
        newData.filterKeyWord = this.keyword.split(" ")
        newData.id = this.requestData.id
        this.$api.editGlobalSetting(newData).then(res => {
          res.data.status == 0 ? 
            (this.$message.success("修改成功！"),
            this.getKeyWord())
            :this._status(res.data)
          
        })
      } else {
        this.$message.info("未修改内容，无需保存设置")
      }
      
    }
  },
}
</script>
<style lang='scss' scoped>
/* @import url(); 引入css类 */
.setbox{
  width: 800px;
  margin: 120px auto;
}
.buttonbox{
  width: 200px;
  margin: auto;
}
</style>